
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h16v16H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M8 10a.645.645 0 00.475-.191.645.645 0 00.192-.475.645.645 0 00-.192-.476A.645.645 0 008 8.667a.645.645 0 00-.475.191.645.645 0 00-.192.476c0 .188.064.347.192.475A.645.645 0 008 10zm-.667-2.667h1.334v-4H7.333v4zm-6 7.334v-12c0-.367.13-.68.392-.942.261-.261.575-.392.942-.392h10.666c.367 0 .68.131.942.392.261.261.392.575.392.942v8c0 .367-.131.68-.392.941a1.284 1.284 0 01-.942.392H4l-2.667 2.667z","fill":"#396BDB"}})])])
          )
        }
      }
    